import axios from 'axios';
import store from '@/store';
import { modulesName } from '@/store';
import {
  SIGNATURE_USER,
  SIGNATURE_PASSWORD,
  SIGNATURE_API,
  NODE_ENV,
} from '@/config';

const getToken = () => {
  return localStorage.getItem('token');
};

const saveToken = (token) => {
  localStorage.setItem('token', token);
};

const authenticate = async () => {
  store.dispatch(`${modulesName.appModuleName}/setLoading`, true);
  const response = await axios.post(
    SIGNATURE_API.BASE_URL + '/api/external/login',
    {
      username: SIGNATURE_USER,
      password: SIGNATURE_PASSWORD,
    }
  );
  const token = response.data.accessToken;
  saveToken(token);
  store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
  return token;
};

const dsApi = axios.create({
  baseURL: SIGNATURE_API.BASE_URL,
  timeout: NODE_ENV === 'production' ? SIGNATURE_API.TIMEOUT : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    tenant: 'DigitalSignatureApi',
  },
});

dsApi.interceptors.request.use(
  async (config) => {
    store.dispatch(`${modulesName.appModuleName}/setLoading`, true);
    let token = getToken();

    if (!token) {
      token = await authenticate();
    }
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

dsApi.interceptors.response.use(
  (response) => {
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);

    return response;
  },
  async (error) => {
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const token = await authenticate();

      originalRequest.headers.Authorization = `Bearer ${token}`;
      return dsApi(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default dsApi;
